import { render } from "./CatalogProductDetail.vue?vue&type=template&id=192f345b&scoped=true&ts=true"
import script from "./CatalogProductDetail.vue?vue&type=script&lang=ts"
export * from "./CatalogProductDetail.vue?vue&type=script&lang=ts"

import "./CatalogProductDetail.vue?vue&type=style&index=0&id=192f345b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192f345b"]])

export default __exports__